import request from '@/utils/request'
import qs from 'qs'
export function login(userName, password) {
  return request({
    url: '/user/login',
    method: 'post',
    data: {
      userName,
      password
    }
  })
}

export function register(data) {
  return request({
    url: '/user/register',
    method: 'post',
    data
  })
}

export function getInfo(token) {
  return request({
    url: '/user/getUserInfoByToken/'+token,
    method: 'get',
    params: {}
  })
}

export function logout(token) {
  return request({
    url: '/user/logout',
    method: 'get',
    params:{ token }
  })
}

export function getRouter() {
  return request({
    url: '/category/getLayers',
    method: 'get',
    params:{}
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js